import { JsonObject } from '../../helpers';
import { ConnectorApiKeyConfig, ConnectorFeatureSet } from './';
import { ConnectorModel } from './connector.model';
import AnthropicIcon from '@/assets/connector-icons/anthropic.svg';

export class AnthropicConnectorModel extends ConnectorModel {
  config: ConnectorApiKeyConfig;

  constructor(props: JsonObject = {}) {
    super(props);

    const data = props as Record<keyof ConnectorModel, unknown>;

    this.type = 'anthropic';
    this.typeLabel = 'Anthropic';
    this.iconSVG = AnthropicIcon;

    this.supportedFeatures = (data.supportedFeatures as ConnectorFeatureSet) || {
      siem: false,
      privateModels: true,
      contextData: false,
      ingress: false,
    };

    this.config = (data.config as ConnectorApiKeyConfig) || {
      apiKey: '',
    };

    this.configSecrets = ['apiKey'];
    this.canListProviderModels = true;
    this.demo = true;
  }
}
